import moment from 'moment/moment';
import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const fetchOrderHistoryListRequest = () => ({
  type: actionTypes.FETCH_ORDER_HISTORY_REQUEST,
  name: 'orderHistoryLoadingStatus',
});

export const fetchOrderHistoryListSuccess = (orderHistory, pagination) => ({
  type: actionTypes.FETCH_ORDER_HISTORY_SUCCESS,
  name: 'orderHistoryLoadingStatus',
  orderHistory,
  pagination,
});

export const fetchOrderHistoryListFailure = () => ({
  type: actionTypes.FETCH_ORDER_HISTORY_FAILURE,
  name: 'orderHistoryLoadingStatus',
});

export const fetchOrderHistoryList =
  (requestPayload = {}) =>
  async (dispatch, getState) => {
    try {
      const { session } = getState();
      const { salesPeriodTimestamp } = session;
      const retailerId = requestPayload.retailerId || session.retailer.retailerId;

      let toDate;
      let fromDate;
      if (requestPayload.filters && requestPayload.filters.toDate) {
        toDate = requestPayload.filters.toDate;
        fromDate = moment(toDate).startOf('month').format('YYYY-MM-DD');
      } else {
        toDate = moment.unix(salesPeriodTimestamp).clone().endOf('month').format('YYYY-MM-DD');
        fromDate = moment.unix(salesPeriodTimestamp).clone().subtract(12, 'M').startOf('month').format('YYYY-MM-DD');
      }

      const requestParams = {
        ...requestPayload,
        filters: { ...requestPayload.filters, fromDate, toDate },
        retailerId,
      };

      dispatch(fetchOrderHistoryListRequest());
      const { content, ...pagination } = await api.fetchOrderHistoryList(requestParams);
      dispatch(fetchOrderHistoryListSuccess(content, pagination));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('FETCH_ORDER_HISTORY', error);
      dispatch(fetchOrderHistoryListFailure());
    }
  };



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/fetch-order-history-list.actions.js